import React, { useState, useEffect } from 'react';
import { linkingCodesService } from '../../services/linkingCodesService';
import {
  studentsService,
  parentsService,
} from '../../services/firestoreService';

const LinkingCodesDebug: React.FC = () => {
  const [codes, setCodes] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');
  const [students, setStudents] = useState<any[]>([]);
  const [parents, setParents] = useState<any[]>([]);

  const fetchAllData = async () => {
    setLoading(true);
    setError('');

    try {
      console.log('Fetching linking codes...');
      const allCodes = await linkingCodesService.getAllCodes();
      console.log('Linking codes:', allCodes);
      setCodes(allCodes);

      console.log('Fetching students...');
      const allStudents = await studentsService.getAll();
      console.log('Students:', allStudents);
      setStudents(allStudents);

      console.log('Fetching parents...');
      const allParents = await parentsService.getAll();
      console.log('Parents:', allParents);
      setParents(allParents);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  };

  const createTestCode = async () => {
    try {
      console.log('Creating test code...');
      const testCode = await linkingCodesService.createLinkingCode(
        'test-student-123',
        'test-teacher-456',
        {
          userType: 'student',
          codeType: 'permanent',
          metadata: {
            testCode: true,
            createdAt: new Date().toISOString(),
          },
        }
      );
      console.log('Test code created:', testCode);
      alert(`تم إنشاء كود اختبار: ${testCode.code}`);
      await fetchAllData(); // إعادة جلب البيانات
    } catch (err) {
      console.error('Error creating test code:', err);
      alert(
        `خطأ في إنشاء الكود: ${
          err instanceof Error ? err.message : 'Unknown error'
        }`
      );
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <div className='p-6 space-y-6'>
      <div className='bg-white dark:bg-gray-800 p-4 rounded-lg'>
        <h2 className='text-xl font-bold mb-4'>تحليل بيانات أكواد الربط</h2>

        <div className='flex gap-4 mb-6'>
          <button
            onClick={fetchAllData}
            disabled={loading}
            className='bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50'
          >
            {loading ? 'جاري التحميل...' : 'إعادة تحميل البيانات'}
          </button>

          <button
            onClick={createTestCode}
            className='bg-green-600 text-white px-4 py-2 rounded'
          >
            إنشاء كود اختبار
          </button>
        </div>

        {error && (
          <div className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4'>
            <strong>خطأ:</strong> {error}
          </div>
        )}

        <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-6'>
          <div className='bg-blue-50 p-4 rounded'>
            <h3 className='font-semibold text-blue-900'>أكواد الربط</h3>
            <p className='text-2xl font-bold text-blue-600'>{codes.length}</p>
          </div>

          <div className='bg-green-50 p-4 rounded'>
            <h3 className='font-semibold text-green-900'>الطلاب</h3>
            <p className='text-2xl font-bold text-green-600'>
              {students.length}
            </p>
          </div>

          <div className='bg-purple-50 p-4 rounded'>
            <h3 className='font-semibold text-purple-900'>أولياء الأمور</h3>
            <p className='text-2xl font-bold text-purple-600'>
              {parents.length}
            </p>
          </div>
        </div>

        <div className='space-y-4'>
          <div>
            <h3 className='font-semibold mb-2'>
              أكواد الربط ({codes.length}):
            </h3>
            <div className='bg-gray-100 p-4 rounded max-h-60 overflow-y-auto'>
              <pre className='text-sm'>{JSON.stringify(codes, null, 2)}</pre>
            </div>
          </div>

          <div>
            <h3 className='font-semibold mb-2'>الطلاب ({students.length}):</h3>
            <div className='bg-gray-100 p-4 rounded max-h-40 overflow-y-auto'>
              <pre className='text-sm'>
                {JSON.stringify(students.slice(0, 3), null, 2)}
              </pre>
            </div>
          </div>

          <div>
            <h3 className='font-semibold mb-2'>
              أولياء الأمور ({parents.length}):
            </h3>
            <div className='bg-gray-100 p-4 rounded max-h-40 overflow-y-auto'>
              <pre className='text-sm'>
                {JSON.stringify(parents.slice(0, 3), null, 2)}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkingCodesDebug;
